import axios from "axios";
import API from "../helpers/api";
import { toast, ToastContainer } from "react-toastify";

// const shortClosed = {
//     TaskType: "shortClosed",
//     poNumber: "",
//     ShortClosedShipName: "",
//     poDescription: "",
//     PODateFrom: "",
//     PODateTo: "",
//     itemDescription: "",
//     supplierName: "",
//     PageNo: 1,
//     PgSize: 25
// }

let user = JSON.parse(localStorage.getItem("currentUser"));
export const getMMPLShipCount = (shipId) => {
  let user = JSON.parse(localStorage.getItem("currentUser"));
  let url = `${API.MMPLShipCount}?mmplMail=${user.email}&shipId=${shipId}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "GetMMPLShipCountSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "GetMMPLShipCountFailure",
          error: "ERROR",
        });
      });
  };
};

// export const getShipPO = (searchItem) => {
//
//     let user = JSON.parse(localStorage.getItem("currentUser"));
// var url = `${API.ShipPO}?mail=${user.email}&shipName=${searchItem.poValidationShipName}&isShortClosed=${searchItem.isShortClosed}&isIhmPart1=${searchItem.isIhmPart1}&isAwaitingMdAndSdoc=${searchItem.isAwaitingMdAndSdoc}&isPoValidation=${searchItem.isPoValidation}&isPurchaseOrders=${searchItem.isPurchaseOrders}`;
// let url = "http://54.144.174.177:8090/api/shipsAndPos?mail=mmpladmin@qantler.com&shipName=&isShortClosed=false&isIhmPart1=false&isAwaitingMdAndSdoc=false&isPoValidation=false&isPurchaseOrders=true"
// console.log("url",url);
// console.log("url1",url1);
// }

export const getClientDetails = (item) => {
  let temp = [
    {
      "clientName": "Synergy Maritime Pvt Limited",
      "ClientId": 0,
      "assignedShipCount": 674,
      "purchaseOrders": 1045,
      "myPendingTasks": 45,
      "awaitingMDSDoc": 34,
      "shipPendingTasks": 2,
      "ihmPart1Pending": 4,
      "ihmPart1Updated": 10,
      "shortClosedPOs": 33,
      "totalShips": 334
    },
    {
      "clientName": "Synergy Maritime Pvt Limited",
      "ClientId": 0,
      "assignedShipCount": 674,
      "purchaseOrders": 1045,
      "myPendingTasks": 45,
      "awaitingMDSDoc": 34,
      "shipPendingTasks": 2,
      "ihmPart1Pending": 4,
      "ihmPart1Updated": 10,
      "shortClosedPOs": 33,
      "totalShips": 334
    },
    {
      "clientName": "Synergy Maritime Pvt Limited",
      "ClientId": 0,
      "assignedShipCount": 674,
      "purchaseOrders": 1045,
      "myPendingTasks": 45,
      "awaitingMDSDoc": 34,
      "shipPendingTasks": 2,
      "ihmPart1Pending": 4,
      "ihmPart1Updated": 10,
      "shortClosedPOs": 33,
      "totalShips": 334
    },
    {
      "clientName": "Synergy Maritime Pvt Limited",
      "ClientId": 0,
      "assignedShipCount": 674,
      "purchaseOrders": 1045,
      "myPendingTasks": 45,
      "awaitingMDSDoc": 34,
      "shipPendingTasks": 2,
      "ihmPart1Pending": 4,
      "ihmPart1Updated": 10,
      "shortClosedPOs": 33,
      "totalShips": 334
    }
  ];
  let url = "";
  return (dispatch) => {
    //   axios
    //   .get(url)
    //     .then((response) => {
    //       dispatch({
    //         type: "GetClientDetailsSuccess",
    //         data: response.data,
    //       });
    //     })
    //     .catch((error) => {
    //       dispatch({
    //         type: "GetClientDetailsFailure",
    //         data: error,
    //       });
    //     });
    dispatch({
      type: "GetClientDetailsSuccess",
      data: temp,
    });
  };

};

export const getShipPO = (item) => {
  let user = JSON.parse(localStorage.getItem("currentUser"));
  let url = `${API.ShipPO}?mail=${user.email}&clientId=${item.clientId ? item.clientId : ""}&shipName=${item.poValidationShipName}&isShortClosed=${item.isShortClosed}&isIhmPart1=${item.isIhmPart1}&isIhmUpdate2=${item.isIhmUpdate2}&isAwaitingMdAndSdoc=${item.isAwaitingMdAndSdoc}&isPoValidation=${item.isPoValidation}&isPurchaseOrders=${item.isPurchaseOrders}&isShipsPendingTask=${item.isShipsPendingTask}&imoNo=${item.poValidationIMONo}`;
  url = url.replace(/\u200B/g, "");
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "GetShipPOsSuccess",
          data: response.data,
        });
        dispatch({ type: "searchSuccess", data: item });
      })
      .catch((error) => {
        dispatch({
          type: "GetShipPOsFailure",
          data: error,
        });
      });
  };
};

export const getMMPLPoValidationSearchlist = (searchItem, PgNo) => {
  let user = JSON.parse(localStorage.getItem("currentUser"));
  let url = `${API.MMPLShipSearch}?Mail=${user.email}&shipId=${searchItem.shipId
    }&TaskType=${searchItem.TaskType}&ShipName=${searchItem.poValidationShipName
    }&poNumber=${btoa(searchItem.poNumber)}&poDescription=${btoa(
      searchItem.poDescription
    )}&PODateFrom=${searchItem.PODateFrom}&PODateTo=${searchItem.PODateTo
    }&supplierName=${btoa(searchItem.supplierName)}&itemDescription=${btoa(
      searchItem.itemDescription
    )}&PageNumber=${PgNo}&PageSize=${searchItem.PgSize}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "GetMMPLPOSearchSuccess",
          data: response.data,
        });
        dispatch({ type: "POSuccess", data: searchItem });
      })
      .catch((error) => {
        dispatch({
          type: "GetMMPLPOSearchFailure",
          error: "ERROR",
        });
      });
  };
};

export const getMMPLMDocSearchlist = (searchItem, PgNo) => {
  let user = JSON.parse(localStorage.getItem("currentUser"));
  let url = `${API.MMPLShipSearch}?Mail=${user.email}&shipId=${searchItem.shipId
    }&TaskType=${searchItem.TaskType}&ShipName=${searchItem.mDocShipName
    }&poNumber=${btoa(searchItem.poNumber)}&poDescription=${btoa(
      searchItem.poDescription
    )}&PODateFrom=${searchItem.PODateFrom}&PODateTo=${searchItem.PODateTo
    }&supplierName=${btoa(searchItem.supplierName)}&itemDescription=${btoa(
      searchItem.itemDescription
    )}&PageNumber=${PgNo}&PageSize=${searchItem.PgSize}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "GetMMPLMdocSearchSuccess",
          data: response.data,
        });
        dispatch({ type: "POSuccess", data: searchItem });
      })
      .catch((error) => {
        dispatch({
          type: "GetMMPLMdocSearchFailure",
          error: "ERROR",
        });
      });
  };
};

export const getMMPLIHMSearchlist = (searchItem, PgNo) => {
  let user = JSON.parse(localStorage.getItem("currentUser"));
  let url = `${API.MMPLShipSearch}?Mail=${user.email}&shipId=${searchItem.shipId
    }&TaskType=${searchItem.TaskType}&ShipName=${searchItem.IHMShipName
    }&poNumber=${btoa(searchItem.poNumber)}&poDescription=${btoa(
      searchItem.poDescription
    )}&PODateFrom=${searchItem.PODateFrom}&PODateTo=${searchItem.PODateTo
    }&supplierName=${btoa(searchItem.supplierName)}&itemDescription=${btoa(
      searchItem.itemDescription
    )}&PageNumber=${PgNo}&PageSize=${searchItem.PgSize}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "GetMMPLIHMSearchSuccess",
          data: response.data,
        });
        dispatch({ type: "POSuccess", data: searchItem });
      })
      .catch((error) => {
        dispatch({
          type: "GetMMPLIHMSearchFailure",
          error: "ERROR",
        });
      });
  };
};

// ----------------------------Short Closed API's----------------------

export const getMMPLShortClosedSearchlist = (searchItem, PgNo) => {
  let user = JSON.parse(localStorage.getItem("currentUser"));
  let url = `${API.MMPLShipSearch}?Mail=${user.email}&shipId=${searchItem.shipId
    }&TaskType=${searchItem.TaskType}&ShipName=${searchItem.ShortClosedShipName
    }&poNumber=${btoa(searchItem.poNumber)}&poDescription=${btoa(
      searchItem.poDescription
    )}&PODateFrom=${searchItem.PODateFrom}&PODateTo=${searchItem.PODateTo
    }&supplierName=${btoa(searchItem.supplierName)}&itemDescription=${btoa(
      searchItem.itemDescription
    )}&PageNumber=${PgNo}&PageSize=${searchItem.PgSize}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "GetMMPLShortClosedSearchSuccess",
          data: response.data,
        });
        dispatch({ type: "POSuccess", data: searchItem });
      })
      .catch((error) => {
        dispatch({
          type: "GetMMPLShortClosedSearchFailure",
          error: "ERROR",
        });
      });
  };
};
export const getMMPLShipPendingSearchlist = (searchItem, PgNo) => {
  let user = JSON.parse(localStorage.getItem("currentUser"));
  let url = `${API.MMPLShipSearch}?Mail=${user.email}&shipId=${searchItem.shipId
    }&TaskType=${searchItem.TaskType}&ShipName=${searchItem.ShortClosedShipName
    }&poNumber=${btoa(searchItem.poNumber)}&poDescription=${btoa(
      searchItem.poDescription
    )}&PODateFrom=${searchItem.PODateFrom}&PODateTo=${searchItem.PODateTo
    }&supplierName=${btoa(searchItem.supplierName)}&itemDescription=${btoa(
      searchItem.itemDescription
    )}&PageNumber=${PgNo}&PageSize=${searchItem.PgSize}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "GetMMPLShipPendingSearchSuccess",
          data: response.data,
        });
        dispatch({ type: "POSuccess", data: searchItem });
      })
      .catch((error) => {
        dispatch({
          type: "GetMMPLShipPendingSearchFailure",
          error: "ERROR",
        });
      });
  };
};

export const putMMPLShortClosedSearchlist = (data, shortClosed) => {
  let url = `${API.ShortClosed}`;
  return (dispatch) => {
    axios
      .put(url, data)
      .then((response) => {
        if (response.data) {
          toast.success("Updated successfully", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          dispatch(
            getMMPLShortClosedSearchlist(shortClosed, shortClosed.PageNo)
          );
          dispatch(getMMPLShipCount(shortClosed.shipId));
        }
        dispatch({
          type: "putMMPLShortClosedSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "putMMPLShortClosedSuccess",
          error: "ERROR",
        });
      });
  };
};

export const addMMPLShortClosedSearchlist = (data, po) => {
  let url = `${API.ShortClosed}`;
  return (dispatch) => {
    axios
      .put(url, data)
      .then((response) => {
        if (response.data) {
          toast.success("Short Closed successfully.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          dispatch(getMMPLPoValidationSearchlist(po, po.PageNo));
          dispatch(getMMPLShipCount(po.shipId));
        }
        dispatch({
          type: "putMMPLShortClosedSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "putMMPLShortClosedSuccess",
          error: "ERROR",
        });
      });
  };
};

// --------------------------------------------------

export const getMMPLShipSearch = (searchItem, pageNo) => {
  let user = JSON.parse(localStorage.getItem("currentUser"));
  let url = `${API.ClientShipSearch}?Mail=${user.email}&clientId=${searchItem.clientId ? searchItem.clientId : ""}&ShipName=${searchItem.shipName}&PageNumber=${pageNo}&PageSize=${searchItem.PgSize}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getMMPLShipSearchSuccess",
          data: response.data,
        });
        dispatch({ type: "searchSuccess", data: searchItem });
      })
      .catch((error) => {
        dispatch({
          type: "getMMPLShipSearchFailure",
          error: "ERROR",
        });
      });
  };
};
export const updateCollectMDocSDoc = (data) => {
  let url = `${API.CollectMDocSDocAPI}`;
  let item = {
    mDocShipName: "",
    TaskType: "collectmdocsdoc",
    PgNo: 1,
    PgSize: 5,
  };
  return (dispatch) => {
    axios
      .put(url, data)
      .then((response) => {
        dispatch(getMMPLMDocSearchlist(item, 1));
        dispatch(getMMPLShipCount(data.shipId));
        toast.success("Document updated successfully.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        dispatch({
          type: "putMDocSDocSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "putMDocSDocFailure",
          error: "ERROR",
        });
      });
  };
};

export const mailCollectMDocSDoc = (data, item) => {
  let url = `${API.MailMDocSDoc}`;
  return (dispatch) => {
    axios
      .put(url, data)
      .then((response) => {
        if (response.data) {
          toast.success("Email Sent Successfully", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
        dispatch(getMMPLMDocSearchlist(item, item.PageNo));
        dispatch({
          type: "mailCollectMDocSDocSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "mailCollectMDocSDocSuccess",
          error: "ERROR",
        });
      });
  };
};

export const holdMailMdocSdoc = (data, item) => {
  let url = `${API.HoldMail}`;
  return (dispatch) => {
    axios
      .put(url, data)
      .then((response) => {
        if (response.data) {
          toast.success("Successfully Updated", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
        dispatch(getMMPLMDocSearchlist(item, item.PageNo));
        dispatch({
          type: "holdmailCollectMDocSDocSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "holdmailCollectMDocSDocSuccess",
          error: "ERROR",
        });
      });
  };
};

// ----------------------------IHM PART 1 UPDATE API's----------------------

export const getPaintCoating = (shipId, poId) => {
  let url = `${API.GetPaintCoating}?shipId=${shipId}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "GetPaintCoatingSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "GetPaintCoatingFailure",
          error: "ERROR",
        });
      });
  };
};

export const getEquipmentMachinery = (shipId, poId) => {
  let url = `${API.GetEquipmentMachinery}?shipId=${shipId}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "GetEquipmentMachinerySuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "GetEquipmentMachineryFailure",
          error: "ERROR",
        });
      });
  };
};

export const getStructureAndHull = (shipId, poId) => {
  let url = `${API.GetStructureHull}?shipId=${shipId}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "GetStructureAndHullSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "GetStructureAndHullFailure",
          error: "ERROR",
        });
      });
  };
};

export const getStores = (shipId, poId) => {
  let url = `${API.GetStore}?shipId=${shipId}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "GetStoreSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "GetStoreFailure",
          error: "ERROR",
        });
      });
  };
};

export const postIhmPartInventory = (data) => {
  let url = `${API.PostInventory}`;
  return (dispatch) => {
    axios
      .post(url, data)
      .then((response) => {
        dispatch({
          type: "PostHazardessMaterialsSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "PostHazardessMaterialsFailure",
          error: "ERROR",
        });
      });
  };
};

export const postPaintAndCoatingSystems = (data) => {
  let url = `${API.MDPostAPI}`;
  return (dispatch) => {
    axios
      .post(url, data)
      .then((response) => {
        dispatch({
          type: "PostPaintAndCoatingSystemsSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "PostPaintAndCoatingSystemsFailure",
          data: "error",
        });
      });
  };
};

export const postEquipmentAndMachinery = (data) => {
  let url = `${API.MDPostAPI}`;
  return (dispatch) => {
    axios
      .post(url, data)
      .then((response) => {
        dispatch({
          type: "PostEquipmentAndMachinerySuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "PostEquipmentAndMachineryFailure",
          data: "error",
        });
      });
  };
};

export const postStructureAndHull = (data) => {
  let url = `${API.MDPostAPI}`;
  return (dispatch) => {
    axios
      .post(url, data)
      .then((response) => {
        dispatch({
          type: "PostStructureAndHullSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "PostStructureAndHullFailure",
          data: "error",
        });
      });
  };
};

export const postStores = (data) => {
  let url = `${API.MDPostAPI}`;
  return (dispatch) => {
    axios
      .post(url, data)
      .then((response) => {
        dispatch({
          type: "PostStoresSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "PostStoresFailure",
          data: "error",
        });
      });
  };
};

export const updatePaintAndCoatingSystems = (data) => {
  let url = `${API.MDUpdateAPI}`;
  return (dispatch) => {
    axios
      .put(url, data)
      .then((response) => {
        dispatch({
          type: "updatePaintAndCoatingSystemsSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "updatePaintAndCoatingSystemsFailure",
          error: "ERROR",
        });
      });
  };
};

export const updateEquipmentAndMachinery = (data) => {
  let url = `${API.MDUpdateAPI}`;
  return (dispatch) => {
    axios
      .put(url, data)
      .then((response) => {
        dispatch({
          type: "updateEquipmentAndMachinerySuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "updateEquipmentAndMachineryFailure",
          error: "ERROR",
        });
      });
  };
};

export const updateStructureAndHull = (data) => {
  let url = `${API.MDUpdateAPI}`;
  return (dispatch) => {
    axios
      .put(url, data)
      .then((response) => {
        dispatch({
          type: "updateStructureAndHullSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "updateStructureAndHullFailure",
          error: "ERROR",
        });
      });
  };
};

export const updateStores = (data) => {
  let url = `${API.MDUpdateAPI}`;
  return (dispatch) => {
    axios
      .put(url, data)
      .then((response) => {
        dispatch({
          type: "updateStoresSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "updateStoresFailure",
          error: "ERROR",
        });
      });
  };
};

export const deletePaintAndCoatingSystems = (id) => {
  let url = `${API.MDDelete}/${id}`;
  return (dispatch) => {
    axios
      .delete(url)
      .then((response) => {
        dispatch({
          type: "PaintAndCoatingSystemsDeleteSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "PaintAndCoatingSystemsDeleteFailure",
          error: "ERROR",
        });
      });
  };
};

export const deleteEquipmentAndMachinery = (id) => {
  let url = `${API.MDDelete}/${id}`;
  return (dispatch) => {
    axios
      .delete(url)
      .then((response) => {
        dispatch({
          type: "EquipmentAndMachineryDeleteSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "EquipmentAndMachineryDeleteFailure",
          error: "ERROR",
        });
      });
  };
};

export const deleteStructureAndHull = (id) => {
  let url = `${API.MDDelete}/${id}`;
  return (dispatch) => {
    axios
      .delete(url)
      .then((response) => {
        dispatch({
          type: "StructureAndHullDeleteSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "StructureAndHullDeleteFailure",
          error: "ERROR",
        });
      });
  };
};

export const deleteStores = (id) => {
  let url = `${API.MDDelete}/${id}`;
  return (dispatch) => {
    axios
      .delete(url)
      .then((response) => {
        dispatch({
          type: "StoresDeleteSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "StoresDeleteFailure",
          error: "ERROR",
        });
      });
  };
};

// ----------------------------Not Used----------------------

export const getMMPLShipDeatil = (shipId) => {
  let url = `${API.MMPLShipDetail + shipId}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "GetMMPLShipDetailSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "GetMMPLShipDetailFailure",
          error: "ERROR",
        });
      });
  };
};

export const getMMPLShipInfo = (info) => {
  var info = {
    ShipId: 1,
    equipmentId: 1,
    equipmentName: "qwe",
    equipmentType: "CO2",
    capacity: "1kg",
    make: "hd",
    model: "mg1",
    manufacturingDate: "2000-01-01",
    quantity: "1",
    category: "xxx",
    additionalInformation: " Additional Information for equipment",
    serviceType: "annually",
    lastDone: "2000-01-01",
    lastServicePort: "India",
    nextDue: "2000-01-01",
    createdBy: "gg",
    createdDate: "2000-01-01",
    modifiedBy: "gg",
    modifiedDate: "2000-01-01",
  };
  return (dispatch) => {
    dispatch({
      type: "GetMMPLIHMSearchSuccess",
      data: info,
    });
  };

  // let url = `${API.GetMMPLShipInfo}?shipId=${info.shipId}&equipmentId=${info.equipmentId}&equipmentServiceId=${info.equipmentServiceId}`;
  // return dispatch => {
  //     axios.get(url)
  //         .then((response) => {
  //             dispatch({
  //                 type: "GetMMPLIHMSearchSuccess",
  //                 data: response.data
  //             })
  //         })
  //         .catch((error) => {
  //             dispatch({
  //                 type: "GetMMPLIHMSearchFailure",
  //                 error: "ERROR"
  //             })
  //         })
  // }
};

export const getMMPLShipDetails = (shipId) => {
  let url = `${API.GetMMPLShipDetails + shipId}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "GetMMPLShipDetailSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "GetMMPLShipDetailFailure",
          error: "ERROR",
        });
      });
  };
};

export const getMMPLShipHistory = (shipId) => {
  var historyDetail = [
    {
      shipId: 1,
      shipEquipmentId: 1,
      equipmentServiceId: 1,
      serviceType: "annually",
      serviceDate: "2000-01-01",
      port: "India",
      remarks: "xxx",
      attachmentName: "aaa.pdf",
      attachmentGuid: "adfadadad",
      createdBy: "SNR",
      creatdeDate: "2000-01-01",
      modifiedBy: "SNR",
      modifiedDate: "2000-01-01",
    },
    {
      shipId: 2,
      shipEquipmentId: 2,
      equipmentServiceId: 1,
      serviceType: "annually",
      serviceDate: "2000-01-01",
      port: "India",
      remarks: "xxx",
      attachmentName: "aaa.pdf",
      attachmentGuid: "adfadadad",
      createdBy: "SNR",
      creatdeDate: "2000-01-01",
      modifiedBy: "SNR",
      modifiedDate: "2000-01-01",
    },
  ];
  return (dispatch) => {
    dispatch({
      type: "GetMMPLShipHistorySuccess",
      data: historyDetail,
    });
  };

  // let url = `${API.GetMMPLShipHistory + shipId}`;
  // return dispatch => {
  //     axios.get(url)
  //         .then((response) => {
  //             dispatch({
  //                 type: "GetMMPLShipHistorySuccess",
  //                 data: response.data
  //             })
  //         })
  //         .catch((error) => {
  //             dispatch({
  //                 type: "GetMMPLShipHistoryFailure",
  //                 error: "ERROR"
  //             })
  //         })
  //     }
};

export const getPriorityShipCount = (shipId) => {
  let user = JSON.parse(localStorage.getItem("currentUser"));
  let url = `${API.MMPLShipCount}?mmplMail=${user.email}&shipId=${shipId}&isPriority=true`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "GetPriorityShipCountSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "GetPriorityShipCountFailure",
          error: "ERROR",
        });
      });
  };
};

export const getPriorityPoValidationSearchlist = (searchItem, PgNo) => {
  let user = JSON.parse(localStorage.getItem("currentUser"));
  let url = `${API.MMPLShipSearch}?Mail=${user.email}&shipId=${searchItem.shipId
    }&TaskType=${searchItem.TaskType}&ShipName=${searchItem.poValidationShipName
    }&poNumber=${btoa(searchItem.poNumber)}&poDescription=${btoa(
      searchItem.poDescription
    )}&PODateFrom=${searchItem.PODateFrom}&PODateTo=${searchItem.PODateTo
    }&supplierName=${btoa(searchItem.supplierName)}&itemDescription=${btoa(
      searchItem.itemDescription
    )}&PageNumber=${PgNo}&PageSize=${searchItem.PgSize}&isPriority=true`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "GetMMPLPOSearchSuccess",
          data: response.data,
        });
        dispatch({ type: "PriorityPOSuccess", data: searchItem });
      })
      .catch((error) => {
        dispatch({
          type: "GetMMPLPOSearchFailure",
          error: "ERROR",
        });
      });
  };
};

export const getPriorityMDocSearchlist = (searchItem, PgNo) => {
  let user = JSON.parse(localStorage.getItem("currentUser"));
  let url = `${API.MMPLShipSearch}?Mail=${user.email}&shipId=${searchItem.shipId
    }&TaskType=${searchItem.TaskType}&ShipName=${searchItem.mDocShipName
    }&poNumber=${btoa(searchItem.poNumber)}&poDescription=${btoa(
      searchItem.poDescription
    )}&PODateFrom=${searchItem.PODateFrom}&PODateTo=${searchItem.PODateTo
    }&supplierName=${btoa(searchItem.supplierName)}&itemDescription=${btoa(
      searchItem.itemDescription
    )}&PageNumber=${PgNo}&PageSize=${searchItem.PgSize}&isPriority=true`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "GetMMPLMdocSearchSuccess",
          data: response.data,
        });
        dispatch({ type: "PriorityPOSuccess", data: searchItem });
      })
      .catch((error) => {
        dispatch({
          type: "GetMMPLMdocSearchFailure",
          error: "ERROR",
        });
      });
  };
};

export const getPriorityIHMSearchlist = (searchItem, PgNo) => {
  let user = JSON.parse(localStorage.getItem("currentUser"));
  let url = `${API.MMPLShipSearch}?Mail=${user.email}&shipId=${searchItem.shipId
    }&TaskType=${searchItem.TaskType}&ShipName=${searchItem.IHMShipName
    }&poNumber=${btoa(searchItem.poNumber)}&poDescription=${btoa(
      searchItem.poDescription
    )}&PODateFrom=${searchItem.PODateFrom}&PODateTo=${searchItem.PODateTo
    }&supplierName=${btoa(searchItem.supplierName)}&itemDescription=${btoa(
      searchItem.itemDescription
    )}&PageNumber=${PgNo}&PageSize=${searchItem.PgSize}&isPriority=true`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "GetMMPLIHMSearchSuccess",
          data: response.data,
        });
        dispatch({ type: "PriorityPOSuccess", data: searchItem });
      })
      .catch((error) => {
        dispatch({
          type: "GetMMPLIHMSearchFailure",
          error: "ERROR",
        });
      });
  };
};

export const getPriorityShortClosedSearchlist = (searchItem, PgNo) => {
  let user = JSON.parse(localStorage.getItem("currentUser"));
  let url = `${API.MMPLShipSearch}?Mail=${user.email}&shipId=${searchItem.shipId
    }&TaskType=${searchItem.TaskType}&ShipName=${searchItem.ShortClosedShipName
    }&poNumber=${btoa(searchItem.poNumber)}&poDescription=${btoa(
      searchItem.poDescription
    )}&PODateFrom=${searchItem.PODateFrom}&PODateTo=${searchItem.PODateTo
    }&supplierName=${btoa(searchItem.supplierName)}&itemDescription=${btoa(
      searchItem.itemDescription
    )}&PageNumber=${PgNo}&PageSize=${searchItem.PgSize}&isPriority=true`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "GetMMPLShortClosedSearchSuccess",
          data: response.data,
        });
        dispatch({ type: "PriorityPOSuccess", data: searchItem });
      })
      .catch((error) => {
        dispatch({
          type: "GetMMPLShortClosedSearchFailure",
          error: "ERROR",
        });
      });
  };
};

export const getPriorityShipSearch = (searchItem, pageNo) => {
  let user = JSON.parse(localStorage.getItem("currentUser"));
  let url = `${API.ClientShipSearch}?Mail=${user.email}&ShipName=${searchItem.shipName}&PageNumber=${pageNo}&PageSize=${searchItem.PgSize}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getMMPLShipSearchSuccess",
          data: response.data,
        });
        console.log("response.data", response.data);
        dispatch({ type: "PriorityPOSuccess", data: searchItem });
      })
      .catch((error) => {
        dispatch({
          type: "getMMPLShipSearchFailure",
          error: "ERROR",
        });
      });
  };
};

export const restorePo = (poId) => {
  let user = JSON.parse(localStorage.getItem("currentUser"));
  console.log("tooSuceess");
  let url = API.RevertPo + poId;
  let url1 = url.replace(/\u200B/g, "");
  return (dispatch) => {
    axios
      .put(url1)
      .then((response) => {
        console.log("tooSuceess");
        window.scrollTo(0, document.body.scrollHeight);
        // dispatch(getMMPLIHMSearchlist(this.state, this.state.PageNo));
        toast.success("Po Revert successfully.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      })
      .catch((error) => { });
  };
};

// ----------------------------MMPLDashboard API's----------------------

export const getClientSearchResult = (item) => {
  //let temp = [];
  let user = JSON.parse(localStorage.getItem("currentUser"));
  let url = `${API.GetClients}?mail=${user.email}&clientName=${item.searchClients.ClientName}&shipName=${item.searchClients.ShipName}&isPurchaseOrders=true&TotalShip=true`;
  return (dispatch) => {
      axios
      .get(url)
        .then((response) => {
          console.log("searchres", response.data, item, url);
          dispatch({
            type: "GetClientSearchResultSuccess",
            //data: !item.searchClients.ClientName && !item.searchClients.ShipName ? temp :response.data,
            data: response.data,
          });
        })
        .catch((error) => {
          dispatch({
            type: "GetClientSearchResultFailure",
            data: error,
          });
          console.log("searcherr", error);
        });
  };
};

// export const getShipsByClientName = (clientname) => {
//   let user = JSON.parse(localStorage.getItem("currentUser"));
//   let url = `${API.GetShips}?mail=${user.email}&clientName=${clientname}`;
//   return (dispatch) => {
//       axios
//       .get(url)
//         .then((response) => {
//           dispatch({
//             type: "GetShipByClientSuccess",
//             data: response.data,
//           });
//         })
//         .catch((error) => {
//           dispatch({
//             type: "GetShipByClientFailure",
//             data: error,
//           });
//         });
//   };
// };

// export const getClientLists = (item) => {
//   let user = JSON.parse(localStorage.getItem("currentUser"));
//   let url = `${API.GetClients}?mail=${user.email}&isPurchaseOrders=${item.isPurchaseOrders}`;
//   return (dispatch) => {
//       axios
//       .get(url)
//         .then((response) => {
//           console.log("clientres", response, item, url);
//           dispatch({
//             type: "GetClientListSuccess",
//             data: response.data,
//           });
//         })
//         .catch((error) => {
//           dispatch({
//             type: "GetClientListFailure",
//             data: error,
//           });
//           console.log("clienterr", error);
//         });
//   };
// };

export const getClients = () => {
  let user = JSON.parse(localStorage.getItem("currentUser"));
  let url = `${API.clientNames}`;
  return (dispatch) => {
      axios
      .get(url)
        .then((response) => {
          dispatch({
            type: "GetClientListSuccess",
            data: response.data.clients,
          });
        })
        .catch((error) => {
          dispatch({
            type: "GetClientListFailure",
            data: error,
          });
        });
  };
};

// ----------------------------MMPLDashboardClient API's----------------------

export const getClassFlagData = (type) => {
  let url = `${API.ClassFlagData}`+ type;
  return (dispatch) => {
      axios
      .get(url)
        .then((response) => {
          dispatch({
            type: type == "class" ? "getClassSuccess" : "getFlagSuccess",
            data: response.data,
          });
        })
        .catch((error) => {
          dispatch({
            type: type == "class" ? "getClassFailure" : "getFlagFailure",
            data: error,
          });
        });
  };
};

export const getShipsByClientId = (clientid) => {
  let user = JSON.parse(localStorage.getItem("currentUser"));
  let url = `${API.ShipPO}?mail=${user.email}&clientId=${clientid}`;
  return (dispatch) => {
      axios
      .get(url)
        .then((response) => {
          dispatch({
            type: "GetShipByClientIdSuccess",
            data: response.data,
          });
        })
        .catch((error) => {
          dispatch({
            type: "GetShipByClientIdFailure",
            data: error,
          });
        });
  };
};

export const getShipPOByClientId = (item) => {
  let shipName = JSON.parse(localStorage.getItem("shipName")) != undefined ?  JSON.parse(localStorage.getItem("shipName")) : item.poValidationShipName
  let user = JSON.parse(localStorage.getItem("currentUser"));
  let url = `${API.ShipPO}?mail=${user.email}&clientId=${item.clientId}&shipName=${shipName}&isShortClosed=${item.isShortClosed}&isIhmPart1=${item.isIhmPart1}&isIhmUpdate2=${item.isIhmUpdate2}&isAwaitingMdAndSdoc=${item.isAwaitingMdAndSdoc}&isPoValidation=${item.isPoValidation}&isPurchaseOrders=${item.isPurchaseOrders}&isShipsPendingTask=${item.isShipsPendingTask}&flag=${item.flag}&classname=${item.class}`;
  url = url.replace(/\u200B/g, "");
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "GetShipPOsByClientIdSuccess",
          data: response.data,
        });
        dispatch({ type: "searchSuccessByClientId", data: item });
      })
      .catch((error) => {
        dispatch({
          type: "GetShipPOsByClientIdFailure",
          data: error,
        });
      });
  };
};
export const getMMPLShipSearchByClientId = (searchItem, pageNo) => {
  let user = JSON.parse(localStorage.getItem("currentUser"));
  let url = `${API.ClientShipSearch}?Mail=${user.email}&clientId=${searchItem.clientId}&ShipName=${searchItem.shipName}&Class=${searchItem.class}&flag=${searchItem.flag}&PageNumber=${pageNo}&PageSize=${searchItem.PgSize}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getMMPLShipSearchByClientIdSuccess",
          data: response.data,
        });
        dispatch({ type: "searchSuccessByClientId", data: searchItem });
      })
      .catch((error) => {
        dispatch({
          type: "getMMPLShipSearchFailure",
          error: "ERROR",
        });
      });
  };
};
export const getShipnameListByClientEmail = (item) => {
  let url = `${API.shipNames}?ClientMail=${item}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getshipByEmailSuccess",
          data: response.data.ships,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getshipByEmailFailure",
          error: "ERROR",
        });
      });
  };
};